import UIConstants from '../constants/UIConstants';

const globalsService = {
    getAssetRoot() {
        return window.assetRoot;
    },

    getLibRoot() {
        return window.jsLibRoot ? window.jsLibRoot : 'https://d2snzxottmona5.cloudfront.net';
    },

    getDeployEnvironment() {
        return window.deployEnvironment;
    },

    getUploaderToken() {
        // todo implement proper csrf token
        return '';
    },

    /**
     * @returns {Array|string[]} Array of Inspera internal language codes. 'en_us' is the default.
     */
    getSupportedLanguages() {
        return window.supportedLanguages || ['en_us'];
    },

    getSupportedContentLanguages() {
        return window.supportedContentLanguages || ['en_us'];
    },

    isLocalhost() {
        return this.getDeployEnvironment() === 'local';
    },

    isProd() {
        return this.getDeployEnvironment() === 'prod';
    },

    isStage() {
        return this.getDeployEnvironment() === 'stage';
    },

    removePlayerLoader() {
        if (window.playerStartupConfig && window.playerStartupConfig.shouldUseNewLoader) {
            const preloaderContainer = document.getElementById(UIConstants.PLAYER_LOADER_SELECTOR_ID);
            if (preloaderContainer) {
                preloaderContainer.parentNode.removeChild(preloaderContainer);
            }
        }
    },

    setTestPlayerReady() {
        this.removePlayerLoader();
        window.testPlayerReady = true;
    },
};

export default globalsService;
